
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const menuItems = [
    { label: 'Inicio', id: 'hero' },
    { label: 'Sobre mí', id: 'about' },
    { label: 'Servicios', id: 'services' },
    { label: 'Galería', id: 'gallery' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-lg shadow-2xl py-3' : 'bg-black/60 backdrop-blur-md py-5'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center cursor-pointer group" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/bbf7646a0d8dd47b9253598fe9d72fca/a105293fe1c45d8b09e78eb42c1df2c7.png"
              alt="Ilusionista Marco Pombo"
              className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="relative text-white hover:text-red-400 transition-all duration-300 cursor-pointer font-medium py-2 px-1 group"
              >
                {item.label}
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-600 transition-all duration-300 group-hover:w-full"></div>
              </button>
            ))}
            
            {/* CTA Button - Same style as other nav items */}
            <button
              onClick={() => scrollToSection('contact')}
              className="relative text-white hover:text-red-400 transition-all duration-300 cursor-pointer font-medium py-2 px-1 group"
            >
              Contacto
              <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-600 transition-all duration-300 group-hover:w-full"></div>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white text-2xl cursor-pointer p-2 rounded-lg hover:bg-white/10 transition-colors duration-300"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 bg-black/95 backdrop-blur-lg rounded-lg border border-red-600/20 shadow-2xl">
            <div className="px-4 py-4 space-y-2">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block w-full text-left text-white hover:text-red-400 hover:bg-red-600/10 transition-all duration-300 py-3 px-4 rounded-lg cursor-pointer font-medium"
                >
                  {item.label}
                </button>
              ))}
              
              {/* Mobile CTA Button - Same style as other mobile nav items */}
              <button
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left text-white hover:text-red-400 hover:bg-red-600/10 transition-all duration-300 py-3 px-4 rounded-lg cursor-pointer font-medium"
              >
                Contacto
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
